"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScopedResetClass = exports.ScopedResetContext = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
/**
 * The CSS class that resets a subtree's typography and link/button styles
 * the way `nano-theme/global-reset` would do page-wide. Provided by
 * `UiProvider` so that surfaces escaping the React tree (Portal containers,
 * fixed-position floaters, MuTxt shells, etc.) can apply the same reset
 * without relying on the host page having installed a global reset.
 *
 * `null` means "do not apply a scoped reset" — typically because the
 * surrounding app has already installed a global reset.
 */
exports.ScopedResetContext = React.createContext(null);
const useScopedResetClass = () => React.useContext(exports.ScopedResetContext);
exports.useScopedResetClass = useScopedResetClass;
